import React from 'react';

import { TruncationContainer } from '@reverbdotcom/commons/src/components/truncation_container';
import { CSPReviews } from './csp_reviews';
import { CoreItem2CspReviews } from '../schemas/rql';

interface IProps {
  csp: CoreItem2CspReviews.Csp;
  refetch: () => void;
  pageOffset: number;
  setTruncationHeight: number;
  inCspCtaSidebarExperiment?: boolean;
}

export function Item2CspReviewsSection({ csp, setTruncationHeight, refetch, inCspCtaSidebarExperiment, pageOffset }: IProps) {
  return (
    <TruncationContainer
      remMaxHeight={setTruncationHeight}
      trackingName="Item2CSPReviews"
    >
      <CSPReviews
        csp={csp}
        offset={pageOffset}
        refetch={refetch}
        inCspCtaSidebarExperiment={inCspCtaSidebarExperiment}
        hideHeading
        truncateAllReviews
      />
    </TruncationContainer>
  );
}
